import { windowExists } from './utils/windowExists';
export const __APPLICATION_SETTINGS = windowExists ? window.__APPLICATION_SETTINGS : null;
//# sourceMappingURL=__applicationSettings.js.map